
(function () {
  'use strict';
 
  // -----------------------------------------------------------------------
  // 1. Redirect rules
  // -----------------------------------------------------------------------
  // Each rule has a target `url` and a list of `phrases`. A query redirects
  // if EVERY word in a phrase has a fuzzy match somewhere in the query.
  // Add as many rules/phrases as you need.
  const searchRedirects = [
    {
      url: '/account', // swap for your subscription app's portal, e.g. '/tools/recurring/login'
      phrases: [
        'subscription',
        'subscriptions',
        'subscribe',
        'manage subscription',
        'my subscription',
        'edit subscription',
        'change subscription',
        'update subscription',
        'cancel subscription',
        'pause subscription',
        'skip subscription',
        'recurring order',
        'recurring orders',
        'repeat order',
        'repeat orders',
        'change date',
        'delivery date',
        'next order date',
      ],
    },
    // Example additional rule:
    // {
    //   url: '/pages/track-order',
    //   phrases: ['track order', 'track my order', 'where is my order', 'order status'],
    // },
  ];
 
  // -----------------------------------------------------------------------
  // 2. Fuzzy matching config
  // -----------------------------------------------------------------------
  const config = {
    maxDistanceRatio: 0.3, // allowed typo distance as a fraction of the target word's length
    minWordLength: 4, // words shorter than this are matched exactly (avoids false positives)
  };
 
  function normalize(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s]/g, '')
      .replace(/\s+/g, ' ');
  }
 
  // Standard Levenshtein edit distance between two strings
  function levenshtein(a, b) {
    const rows = a.length + 1;
    const cols = b.length + 1;
    const matrix = new Array(rows);
 
    for (let i = 0; i < rows; i++) {
      matrix[i] = new Array(cols);
      matrix[i][0] = i;
    }
    for (let j = 0; j < cols; j++) matrix[0][j] = j;
 
    for (let i = 1; i < rows; i++) {
      for (let j = 1; j < cols; j++) {
        if (a[i - 1] === b[j - 1]) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = 1 + Math.min(matrix[i - 1][j], matrix[i][j - 1], matrix[i - 1][j - 1]);
        }
      }
    }
 
    return matrix[rows - 1][cols - 1];
  }
 
  function fuzzyWordMatch(word, target) {
    if (word === target) return true;
    if (word.length < config.minWordLength || target.length < config.minWordLength) return false;
 
    const distance = levenshtein(word, target);
    const allowedDistance = Math.max(1, Math.floor(target.length * config.maxDistanceRatio));
 
    return distance <= allowedDistance;
  }
 
  function queryMatchesPhrase(queryWords, phrase) {
    const phraseWords = normalize(phrase).split(' ');
 
    return phraseWords.every((phraseWord) => queryWords.some((queryWord) => fuzzyWordMatch(queryWord, phraseWord)));
  }
 
  function findRedirectUrl(query) {
    const normalized = normalize(query);
    if (!normalized) return null;
 
    const queryWords = normalized.split(' ');
 
    for (const rule of searchRedirects) {
      for (const phrase of rule.phrases) {
        if (queryMatchesPhrase(queryWords, phrase)) {
          return rule.url;
        }
      }
    }
 
    return null;
  }
 
  // -----------------------------------------------------------------------
  // 3. Hook into search forms (header popdown, /search page, predictive search)
  // -----------------------------------------------------------------------
  function init() {
    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.action || form.action.indexOf('/search') === -1) return;
 
        const input = form.querySelector('input[type="search"]');
        if (!input || !input.value.trim()) return;
 
        const redirectUrl = findRedirectUrl(input.value);
        if (redirectUrl) {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.href = redirectUrl;
        }
      },
      true // capture phase, runs before the theme's own search/predictive-search handlers
    );
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();